<form [formGroup]="form" class="vertical-form" novalidate>
  <div fxLayout="row" fxLayoutGap="20px">
    <div fxLayout="column" fxFlex="40%">
      <mat-form-field fxFlex style="min-width: 100px;">
        <mat-label>Scheme Name</mat-label>
        <input (input)="onInput($event)" matInput type="text" placeholder=""
          formControlName="schemeName" step="1" autocomplete="off">
        @if (form.get('schemeName').errors?.required) {
          <mat-error>Field required</mat-error>
        }
        @if (form.get('schemeName').errors?.maxlength) {
          <mat-error>Scheme name should be fewer than 300 characters</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  @if (!isHandshakeQR) {
    <br>
    <mat-card appearance="outlined">
      <mat-card-content>
        <div fxLayout="row">
          <h4 style="margin-bottom: 0;">Scheme Rules</h4>
        </div>
        <div fxLayout="row" fxLayoutGap="20px">
          <div fxLayout="column" fxFlex>
            <app-scheme-rule #schemeRule [strategyType]="strategyType" [scheme]="scheme"
            [advertiserId]="advertiserId"></app-scheme-rule>
          </div>
          <div fxLayout="column" fxFlex="70%">
            <app-product-rules-edit [captureToolType]="captureToolType" #productRules></app-product-rules-edit>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }

  @if (!isHandshakeQR) {
    <br>
    <mat-card appearance="outlined">
      <mat-card-content>
        <div fxLayout="row" fxLayoutGap="20px">
          <!-- col left -->
          <div fxFlex fxLayout="column" fxLayoutAlign="start">
            <div class="section-title">Limits</div>
            <div class="space-bottom" fxLayout="row" fxLayoutGap="10px">
              <div fxFlex class="box" fxLayout="column">
                <h5>{{ strategyType == 'Stamps' ? 'Stamps': 'Points'}} Limit</h5>
                <div fxLayout="column">
                  <mat-form-field fxFlex style="min-width: 100px;">
                    <mat-label>Limit {{ strategyType }} received</mat-label>
                    <input matInput type="number" placeholder=""
                      formControlName="timeLimitMaxLimit" step="1" autocomplete="off">
                    @if (form.get('timeLimitMaxLimit').errors?.required) {
                      <mat-error>Field
                      required</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field fxFlex style="min-width: 50px;">
                    <mat-label>Limit interval ({{ displayDuration(form.value.timeLimitInterval) || 'hh:mm:ss' }})</mat-label>
                    <input matInput type="text"
                      placeholder=""
                      formControlName="timeLimitInterval" autocomplete="off">
                    @if (form.get('timeLimitInterval').errors?.required) {
                      <mat-error>Field
                      required</mat-error>
                    }
                    @if (form.get('timeLimitInterval').errors?.invalidTs) {
                      <mat-error>Invalid format
                        ('hh:mm:ss')
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div fxFlex class="box" fxLayout="column">
                <h5>Consumption Limit</h5>
                <div fxLayout="column">
                  <mat-form-field fxFlex style="min-width: 100px;">
                    <mat-label>Limit consumption events (QR/Receipt scans)</mat-label>
                    <input matInput type="number" placeholder=""
                      formControlName="consumptionLimitMaxLimit" step="1" autocomplete="off">
                    @if (form.get('consumptionLimitMaxLimit').errors) {
                      <mat-error>Field required</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field fxFlex style="min-width: 50px;">
                    <mat-label>Limit interval ({{ displayDuration(form.value.consumptionLimitInterval) || 'hh:mm:ss' }})</mat-label>
                    <input matInput type="text"
                      placeholder=""
                      formControlName="consumptionLimitInterval" autocomplete="off">
                    @if (form.get('consumptionLimitInterval').errors?.required) {
                      <mat-error
                        >Field
                        required
                      </mat-error>
                    }
                    @if (form.get('consumptionLimitInterval').errors?.invalidConsumptionTs) {
                      <mat-error>Invalid
                        format
                      ('hh:mm:ss')</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }

  @if (isHandshakeQR) {
    <mat-card appearance="outlined">
      <mat-card-content>
        <mat-card-title>Handshake Configuration</mat-card-title>
        <div fxLayout="row" fxLayoutGap="20px">
          <!-- col left -->
          <div fxFlex fxLayout="column" fxLayoutAlign="start">
            <div class="section-title">Handshake Settings</div>
            <div class="space-bottom" fxLayout="row" fxLayoutGap="10px">
              <div fxFlex class="box" fxLayout="column">
                <h5>QR Code Duration</h5>
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-bottom: 10px;">
                  <mat-slide-toggle formControlName="enableQrDuration" color="primary">
                    Enable QR Duration Limit
                  </mat-slide-toggle>
                </div>
                <mat-form-field fxFlex style="min-width: 50px;" [class.disabled]="!form.get('enableQrDuration').value">
                  <mat-label>Duration ({{ displayDuration(form.value.periodDurationQrCode) || 'hh:mm:ss' }})</mat-label>
                  <input matInput type="text"
                    placeholder=""
                    formControlName="periodDurationQrCode"
                    autocomplete="off">
                  @if (form.get('periodDurationQrCode').errors?.required) {
                    <mat-error>Field required</mat-error>
                  }
                  @if (form.get('periodDurationQrCode').errors?.invalidTs) {
                    <mat-error>Invalid format ('hh:mm:ss')</mat-error>
                  }
                </mat-form-field>
              </div>
              <div fxFlex class="box" fxLayout="column">
                <h5>Distance Allowed</h5>
                <div style="margin-bottom: 10px;">
                  <mat-slide-toggle formControlName="enableDistanceLimit" color="primary">
                    Enable Distance Limit
                  </mat-slide-toggle>
                </div>
                <mat-form-field style="min-width: 100px;" [class.disabled]="!form.get('enableDistanceLimit').value">
                  <mat-label>Maximum Distance (meters)</mat-label>
                  <input matInput type="number" placeholder=""
                    formControlName="distanceAllowed"
                    step="1" autocomplete="off">
                  @if (form.get('distanceAllowed').errors?.required) {
                    <mat-error>Field required</mat-error>
                  }
                  @if (form.get('distanceAllowed').errors?.min) {
                    <mat-error>Value must be greater than 0</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="section-title">Reward Points</div>
            <div class="space-bottom" fxLayout="row" fxLayoutGap="10px">
              <div fxFlex class="box" fxLayout="column">
                <h5>QR Generator</h5>
                <mat-form-field fxFlex style="min-width: 100px;">
                  <mat-label>Points received</mat-label>
                  <input matInput type="number" placeholder=""
                    formControlName="senderPoints" step="1" autocomplete="off">
                  @if (form.get('senderPoints').errors?.required) {
                    <mat-error>Field required</mat-error>
                  }
                  @if (form.get('senderPoints').errors?.min) {
                    <mat-error>Value must be greater than 0</mat-error>
                  }
                </mat-form-field>
              </div>
              <div fxFlex class="box" fxLayout="column">
                <h5>QR Scanner</h5>
                <mat-form-field fxFlex style="min-width: 100px;">
                  <mat-label>Points received</mat-label>
                  <input matInput type="number" placeholder=""
                    formControlName="receiverPoints" step="1" autocomplete="off">
                  @if (form.get('receiverPoints').errors?.required) {
                    <mat-error>Field required</mat-error>
                  }
                  @if (form.get('receiverPoints').errors?.min) {
                    <mat-error>Value must be greater than 0</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="section-title">Limit Points</div>
            <div class="space-bottom" fxLayout="row" fxLayoutGap="10px">
              <div fxFlex class="box" fxLayout="column">
                <h5>QR Generator Limit</h5>
                <div fxLayout="column">
                  <mat-form-field fxFlex style="min-width: 100px;">
                    <mat-label>Max points per interval</mat-label>
                    <input matInput type="number" placeholder=""
                      formControlName="senderPointsLimit" step="1" autocomplete="off">
                    @if (form.get('senderPointsLimit').errors?.required) {
                      <mat-error>Field required</mat-error>
                    }
                    @if (form.get('senderPointsLimit').errors?.min) {
                      <mat-error>Value must be greater than 0</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field fxFlex style="min-width: 50px;">
                    <mat-label>Limit interval ({{ displayDuration(form.value.senderPointsInterval) || 'hh:mm:ss' }})</mat-label>
                    <input matInput type="text"
                      placeholder=""
                      formControlName="senderPointsInterval"
                      pattern="^([0-9]{1,2}):([0-5][0-9]):([0-5][0-9])$"
                      autocomplete="off">
                    @if (form.get('senderPointsInterval').errors?.required) {
                      <mat-error>Field required</mat-error>
                    }
                    @if (form.get('senderPointsInterval').errors?.pattern) {
                      <mat-error>Invalid format ('hh:mm:ss')</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div fxFlex class="box" fxLayout="column">
                <h5>QR Scanner Limit</h5>
                <div fxLayout="column">
                  <mat-form-field fxFlex style="min-width: 100px;">
                    <mat-label>Max points per interval</mat-label>
                    <input matInput type="number" placeholder=""
                      formControlName="receiverPointsLimit" step="1" autocomplete="off">
                    @if (form.get('receiverPointsLimit').errors?.required) {
                      <mat-error>Field required</mat-error>
                    }
                    @if (form.get('receiverPointsLimit').errors?.min) {
                      <mat-error>Value must be greater than 0</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field fxFlex style="min-width: 50px;">
                    <mat-label>Limit interval ({{ displayDuration(form.value.receiverPointsInterval) || 'hh:mm:ss' }})</mat-label>
                    <input matInput type="text"
                      placeholder=""
                      formControlName="receiverPointsInterval"
                      pattern="^([0-9]{1,2}):([0-5][0-9]):([0-5][0-9])$"
                      autocomplete="off">
                    @if (form.get('receiverPointsInterval').errors?.required) {
                      <mat-error>Field required</mat-error>
                    }
                    @if (form.get('receiverPointsInterval').errors?.pattern) {
                      <mat-error>Invalid format ('hh:mm:ss')</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="section-title">Limit QR Generation/Scan</div>
            <div class="space-bottom" fxLayout="row" fxLayoutGap="10px">
              <div fxFlex class="box" fxLayout="column">
                <h5>QR Generation Limit</h5>
                <div fxLayout="column">
                  <mat-form-field fxFlex style="min-width: 100px;">
                    <mat-label>Max QR generations per interval</mat-label>
                    <input matInput type="number" placeholder=""
                      formControlName="maxQrGenerationsLimit" step="1" autocomplete="off">
                    @if (form.get('maxQrGenerationsLimit').errors?.min) {
                      <mat-error>Value must be greater than 0</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field fxFlex style="min-width: 50px;">
                    <mat-label>Generation interval ({{ displayDuration(form.value.qrGenerationInterval) || 'hh:mm:ss' }})</mat-label>
                    <input matInput type="text"
                      placeholder=""
                      formControlName="qrGenerationInterval"
                      pattern="^([0-9]{1,2}):([0-5][0-9]):([0-5][0-9])$"
                      autocomplete="off">
                    @if (form.get('qrGenerationInterval').errors?.pattern) {
                      <mat-error>Invalid format ('hh:mm:ss')</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
              <div fxFlex class="box" fxLayout="column">
                <h5>QR Scanner Limit</h5>
                <div fxLayout="column">
                  <mat-form-field fxFlex style="min-width: 100px;">
                    <mat-label>Max QR can scan per interval</mat-label>
                    <input matInput type="number" placeholder=""
                      formControlName="maxScannerLimit" step="1" autocomplete="off">
                    @if (form.get('maxScannerLimit').errors?.min) {
                      <mat-error>Value must be greater than 0</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field fxFlex style="min-width: 50px;">
                    <mat-label>Scanner limit interval ({{ displayDuration(form.value.scannerInterval) || 'hh:mm:ss' }})</mat-label>
                    <input matInput type="text"
                      placeholder=""
                      formControlName="scannerInterval"
                      pattern="^([0-9]{1,2}):([0-5][0-9]):([0-5][0-9])$"
                      autocomplete="off">
                    @if (form.get('scannerInterval').errors?.pattern) {
                      <mat-error>Invalid format ('hh:mm:ss')</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }
</form>